import { SCREENS, REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = { currentScreen: SCREENS.PROGRESS };

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.REPEAT_ONBOARDING:
    case REDUX_ACTIONS.START_OBOARDING:
      return { currentScreen: SCREENS.INTRO };
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { currentScreen: payload };

    default:
      return state;
  }
};

export default screenReducer;
